import React, { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Navbar2 from "../../components/Navbar2/Navbar2";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import client, { urlFor } from "../../sanity/sanityClient";
import { PortableText } from "@portabletext/react";

const BlogDetailsFull = () => {
  const { slug } = useParams(); // Get slug from URL
  const [event, setEvent] = useState(null); // State to store the event details
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch event data from Sanity
    client
      .fetch(
        `*[_type == "event" && slug.current == $slug][0]{
          title,
          body,
          mainImage,
          date,
          time,
          location
        }`,
        { slug }
      )
      .then((data) => {
        setEvent(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Sanity fetch error:", error);
        setLoading(false);
      });
  }, [slug]);

  if (loading) {
    return <p>Loading event details...</p>;
  }

  if (!event) {
    return <p>Event not found!</p>;
  }

  return (
    <Fragment>
      <Navbar2 />
      <PageTitle pageTitle={event.title} pagesub={"Event"} />
      <div className="event-details">
        {/* Main Image */}
        {event.mainImage && (
          <img
            src={urlFor(event.mainImage).url()}
            alt={event.title}
            className="main-image"
          />
        )}

        {/* Event Information */}
        <p>
          <strong>Date:</strong> {event.date}
        </p>
        <p>
          <strong>Time:</strong> {event.time}
        </p>
        <p>
          <strong>Location:</strong> {event.location}
        </p>

        {/* Event Body Rendered with Portable Text */}
        <div className="event-body">
          <PortableText value={event.body} />
        </div>
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default BlogDetailsFull;
